import React, {useEffect, useState} from "react";
import TopBanner from "./topBanner";
import BecomePartner from "./becomePartner";
import LoggingIn from "./loggingIn";
import BasicInfoV2 from "./basicInfoV2";
import PhoneVerification from "./phoneVerification";
import { useSelector } from "react-redux";

const states = {
    INIT: "INIT",
    BASIC_INFO: "BASIC_INFO",
    PHONE_VERIFICATION: "PHONE_VERIFICATION",
    LOGGING_IN: "LOGGIN_IN",
}

const stateSequence = [states.INIT, states.BASIC_INFO, states.PHONE_VERIFICATION, states.LOGGING_IN];

const SignupV2Wrapper = () => {
    const signupState = useSelector(state => state.signingUpState);
    const [state, setState] = useState(states.INIT); 
    const [formdata, setFormdata] = useState({});


    const getStateWiseForm = () => {
        switch (state) {
            case states.BASIC_INFO:
                return <BasicInfoV2 setFormdata={setFormdata} formdata={formdata} 
                    handleNext={() => setState(states.PHONE_VERIFICATION)} handleBack={() => setState(states.INIT)}/>

            case states.PHONE_VERIFICATION:
                return <PhoneVerification setFormdata={setFormdata} formdata={formdata} 
                handleNext={() => {setState(states.LOGGING_IN)}} handleBack={() => setState(states.BASIC_INFO)}/>

            case states.INIT:
            default:
                return <BecomePartner handleNext={() => setState(states.BASIC_INFO)}/>
        }
    }

    useEffect(() => {
        if (signupState === false) {
            setState(states.BASIC_INFO);
        }
    }, [signupState]);

    if (state === states.LOGGING_IN)
        return (
            <div>
                <TopBanner total={stateSequence.length} progress={stateSequence.indexOf(state) + 1}/>
                <LoggingIn/>
            </div>
        );

    return (
        <div>
            <TopBanner total={stateSequence.length} progress={stateSequence.indexOf(state) + 1}/>
            <div className="signup-forms-back">
                <div className="signup-forms-wrapper">{getStateWiseForm()}</div>
            </div>
        </div>
    )
}

export default SignupV2Wrapper